import { useLocation, useParams } from "react-router-dom";

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const useBreadcrumbs = () => {
  const location = useLocation();
  const { dialogId } = useParams();

  let crumbs = location?.pathname
    ?.split("/")
    ?.filter((item) => item !== "")
    ?.map((crumb, idx) => ({
      itemKey: crumb,
      id: crumb,
      caption: capitalize(crumb),
      to: `/${location?.pathname
        ?.split("/")
        .slice(1, idx + 2)
        .join("/")}`,
    }));

  // Remove the last crumb if it matches dialogId
  if (crumbs.length > 0 && crumbs[crumbs.length - 1].id === dialogId) {
    crumbs = crumbs.slice(0, -1);
  }

  // Prepend "home"
  const homeCrumb = {
    itemKey: "home",
    id: "home",
    caption: "Home",
    to: "/",
  };

  return [homeCrumb, ...(crumbs || [])];
};

export default useBreadcrumbs;
